/* eslint-disable */
import React, { useState, useEffect } from "react";
import { FaAngleDoubleRight, FaArrowRight, FaCheckCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

const DevBuildArea = () => {
  const [showMeetings, setShowMeetings] = useState(false);

  useEffect(() => {
    if (!showMeetings) return;

    const existingScript = document.querySelector("script[data-hs-meetings]");

    if (!existingScript) {
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js";
      s.setAttribute("data-hs-meetings", "true");
      s.onload = () => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      };
      document.body.appendChild(s);
    } else {
      setTimeout(() => {
        if (window.HubSpotConversations) {
          window.HubSpotConversations.widget.refresh();
        }
      }, 100);
    }
  }, [showMeetings]);

  // =========================
  // Evolvelab Build Content
  // =========================
  const outcomes = [
    "A real, working product (not a deck)",
    "Clean, scalable production-grade codebase",
    "Clear documentation & handover",
    "Sprint demos, checkpoints, and visible progress",
    "A 6–12 month product roadmap after launch",
  ];

  const forWho = [
    "Founders with a validated idea who need a real product",
    "Startups preparing for pilots, customers, or fundraising",
    "Companies rebuilding or modernizing core software",
    "Teams that want clean, scalable, production-ready code",
    "Businesses that need AI, data, or automation done properly",
  ];

  const problem = [
    "Most programs advise — they don’t build",
    "Most agencies deliver code with no ownership",
    "Most accelerators stop at decks",
    "Most builds fail due to weak architecture & unclear scope",
    "Most teams waste months rebuilding what should have shipped",
  ];

  const deliverablesLeft = [
    "Embedded product leaders & senior engineers",
    "Sprint-based delivery with demos and checkpoints",
    "Real frontend, backend, APIs, data pipelines",
    "AI/ML features only when they add measurable value",
    "Clean architecture that scales beyond MVP",
  ];

  const deliverablesRight = [
    "Web & mobile applications",
    "Backend services & APIs",
    "AI & ML-enabled features (when relevant)",
    "Data pipelines & automation",
    "Secure, scalable technical foundations",
  ];

  const whyChoose = [
    "Delivery ownership — not oversight",
    "UX-first, architecture-driven execution",
    "Senior builders, not junior resources",
    "Built for real users, pilots, and scale",
    "No lock-in — you own everything",
  ];

  const notIncluded = [
    "Marketing or paid ads",
    "Sales execution",
    "Legal or accounting services",
    "Undefined feature creep",
  ];

  const afterProgram = [
    "A real, working product",
    "Clean, scalable code",
    "Clear technical documentation",
    "Confident next-step roadmap",
    "A product ready for users, pilots, and funding",
  ];

  return (
    <>
      {/* ===================== Service Details Area start ===================== */}
      <div className="service-area pd-bottom-90 jumpstart-page">
        <div className="container">
          <div className="row">
            {/* LEFT SIDEBAR */}
            <div className="col-lg-4 col-12 order-2 order-lg-1">
              <div className="td-sidebar service-sidebar">
                <div className="widget widget_catagory">
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Funding Program
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/funding/jumpstart" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Jumpstart</Link></li>
                                    <li><Link to="/funding/boost" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Boost</Link></li>
                                    <li><Link to="/funding/advisory" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Fund Advisory</Link></li>
                                  </ul>
                
                                  <div style={{ height: '16px' }}></div>
                                  <h5 className="widget-title" style={{ color: '#50af9b', cursor: 'pointer', transition: 'color 0.3s ease' }} onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#50af9b'}>
                                    <FaArrowRight />Dev Accelerator
                                  </h5>
                                  <ul className="catagory-items">
                                    <li><Link to="/accelerator/dev-sprint" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Sprint</Link></li>
                                    <li><Link to="/accelerator/dev-build" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Build</Link></li> 
                                    <li><Link to="/accelerator/dev-scale" onMouseEnter={(e) => e.target.style.color = '#50af9b'} onMouseLeave={(e) => e.target.style.color = '#000000'}>Evolvelab Dev Scale</Link></li>
                                  </ul>
                                </div>

                <div className="widget widget_author text-center">
                  
                  <div className="details">
                    <button
                      type="button"
                      className="btn btn-base-color border-radius-5 d-flex align-items-center"
                      style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                      onClick={() => setShowMeetings((s) => !s)}
                    >
                      Book a Free Build Readiness Call +
                    </button>

                    {showMeetings && (
                      <div className="mt-3">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Download
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="/assets/pdf/Evolvelab_Build.pdf"
                        style={{ color: "#000000" }}
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Download the Program Overview{" "}
                        <FaAngleDoubleRight
                          style={{ background: "rgba(170, 237, 222, 1)" }}
                          onMouseEnter={(e) => (e.target.style.background = "#50af9b")}
                          onMouseLeave={(e) =>
                            (e.target.style.background = "rgba(170, 237, 222, 1)")
                          }
                        />
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="widget widget_download">
                  <h5
                    className="widget-title"
                    style={{
                      color: "#50af9b",
                      cursor: "pointer",
                      transition: "color 0.3s ease",
                    }}
                    onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                    onMouseLeave={(e) => (e.target.style.color = "#50af9b")}
                  >
                    <FaArrowRight /> Build Snapshot
                  </h5>
                  <ul>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Fixed Fee: CAD $25,000 – $45,000
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Timeline: 12–16 weeks
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Delivery: Sprint-based demos & milestones
                      </a>
                    </li>
                    <li>
                      <a
                        href="#pricing"
                        onMouseEnter={(e) => (e.target.style.color = "#50af9b")}
                        onMouseLeave={(e) => (e.target.style.color = "#000000")}
                      >
                        Ownership: You own everything
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div className="col-lg-8 order-1 order-lg-2">
              <div className="blog-details-page-content">
                <div className="single-blog-inner mb-0">
                  {/* HERO IMAGE with VIDEO BACKGROUND */}
                  <div
                    className="thumb"
                    style={{
                      position: "relative",
                      overflow: "hidden",
                      minHeight: "400px",
                      margin: 0,
                    }}
                  >
                    <video
                      autoPlay
                      muted
                      loop
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        zIndex: 0,
                      }}
                    >
                      <source src="/assets/video/build.mp4" type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                  <div
                    className="details"
                    style={{ position: "relative", zIndex: 1, padding: "50px" }}
                  >
                    {/* HERO COPY */}
                    <p className="mb-2" style={{ fontSize: '1.75rem', fontWeight: 700 }}>Evolvelab Build</p>
                    <h1>Turn Your Idea Into Working Software — Not Slides</h1>

                    <p className="mb-2">
                      Stop pitching concepts.
                      <br />
                      Start shipping product.
                    </p>

                    <p>
                      Evolvelab Build is a 12–16 week hands-on product and software build program for
                      startups and businesses that are done planning and ready to launch real systems.
                    </p>

                    <p>
                      <b>We don’t advise. We don’t outsource. We build — with you.</b>
                    </p>

                    {/* KEY OUTCOME LIST */}
                    <h5 className="mt-4">What you’ll walk away with:</h5>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {outcomes.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>

                    {/* WHO IT'S FOR */}
                    <h4>Who This Is For</h4>
                    <p>Evolvelab Build is designed for:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {forWho.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>
                      <b>If you want working software, not theoretical roadmaps — this is for you.</b>
                    </p>

                    {/* PROBLEM */}
                    <h4>What Makes Evolvelab Build Different</h4>
                    <p>Most teams waste time because execution is broken:</p>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {problem.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>Evolvelab Build does the work.</b></p>

                    {/* WHAT YOU GET */}
                    <h4>What We Actually Build</h4>
                    <p>During the Build engagement, we deliver real systems — not placeholders.</p>

                    <div className="row">
                      <div className="col-md-6">
                        <h6 className="mt-2">How we build</h6>
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesLeft.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <h6 className="mt-2">What we build</h6>
                        <ul className="single-list-inner style-check style-check mb-3">
                          {deliverablesRight.map((x) => (
                            <li key={x}>
                              <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>

                    <p><b>Every sprint delivers visible progress.</b></p>

                    {/* HOW IT WORKS */}
                    <h4 id="how-it-works">How Evolvelab Build Works</h4>

                    <h6 className="mt-3">Phase 1: Product & Architecture Foundation</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Product discovery & UX research</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> User flows, personas, and success metrics</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Feature definitions & development backlog</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> System architecture & tech stack selection</li>
                    </ul>

                    <h6>Phase 2: Active Software Build</h6>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Frontend & backend development</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Core application logic & integrations</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> AI, data, or automation implementation</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Sprint demos & continuous testing</li>
                    </ul>

                    <h6>Phase 3: Launch, Handover & Scale</h6>
                    <ul className="single-list-inner style-check style-check mb-4">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> QA, stability & performance checks</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Deployment & infrastructure setup</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Full documentation & code handover</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> 6–12 month product roadmap</li>
                    </ul>

                    {/* TEAM */}
                    <h4>Your Embedded Build Team</h4>
                    <p>You don’t hire contractors. You get an embedded execution team.</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Senior product managers</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Software engineers</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Solution architects</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> UX/UI designers</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> AI & data specialists</li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> DevOps engineers</li>
                    </ul>
                    <p><b>Led directly by Evolvelab leadership.</b></p>

                    {/* WHY CHOOSE */}
                    <h4>Why Founders Choose Evolvelab Build</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      {whyChoose.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p>We design and build your product as if we were founding it ourselves.</p>

                    {/* PRICING */}
                    <h4 id="pricing">Pricing & Timeline</h4>
                    <ul className="single-list-inner style-check style-check mb-3">
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Fixed Fee: <b>CAD $25,000 – $45,000</b></li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Timeline: <b>12–16 weeks</b></li>
                      <li><FaCheckCircle style={{ color: "#50af9b" }} /> Delivery: <b>Sprint-based with demos and milestones</b></li>
                    </ul>
                    <p><b>No hourly surprises. No vague deliverables. No unfinished handoffs.</b></p>

                    {/* NOT INCLUDED */}
                    <h4>What This Is Not</h4>
                    <p>To be clear, Evolvelab Build does not include:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {notIncluded.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>This focus is exactly why we ship successfully.</b></p>

                    {/* RESULT */}
                    <h4>The Result</h4>
                    <p>After Evolvelab Build, you will have:</p>
                    <ul className="single-list-inner style-check style-check mb-4">
                      {afterProgram.map((x) => (
                        <li key={x}>
                          <FaCheckCircle style={{ color: "#50af9b" }} /> {x}
                        </li>
                      ))}
                    </ul>
                    <p><b>No more guessing. No more rebuilding.</b></p>

                    {/* FINAL CTA */}
                    <h4>Ready to Build the Right Product — the Right Way?</h4>
                    <p>
                      If you’re serious about turning your idea into real software, Evolvelab Build is your execution partner.
                    </p>

                    <div className="d-flex flex-wrap gap-2 mt-3">
                      <button
                        type="button"
                        className="btn btn-base-color border-radius-5"
                        style={{ backgroundColor: "#50af9b", borderColor: "#50af9b" }}
                        onClick={() => setShowMeetings((s) => !s)}
                      >
                        📅 Book a Free Build Readiness Call
                      </button>

          

                      <Link className="btn btn-black border-radius-5" to="/apply">
                        🚀 Apply for the Next Build Cohort
                      </Link>
                    </div>

                    {showMeetings && (
                      <div className="mt-4">
                        <div
                          className="meetings-iframe-container"
                          data-src="https://meetings.hubspot.com/mike-qureshi?embed=true"
                        ></div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
      {/* ===================== Service Details Area End ===================== */}
    </>
  );
};

export default DevBuildArea;